module.exports = __webpack_public_path__ + "img/fast-down.b63c79b.png";